import { Button, Dialog } from 'ui';
import { default as React } from 'react';
import useDialogLoginStage from './useDialogLoginStage';

const DialogLoginStage = ({ open, onClick, onSuccess }) => {
  const { t, stages } = useDialogLoginStage({ onSuccess });

  return (
    <Dialog title={t('login:Selecciona una etapa para continuar')} size="m" isOpen={open} className={'dialog-login-stage'}>
      <div className="dialog-login-stage__list">
        {stages.map((stage, index) => (
          <Button
            key={stage.guid}
            size="sm"
            onClick={() => onClick(stage)}
            variant="primary-ghost"
            text={stage.name}
            rightIcon="chevron-right"
            isFullWidth
          />
        ))}
      </div>
    </Dialog>
  );
};

DialogLoginStage.defaultProps = {
  open: false,
  onClick: function () {},
};

export default DialogLoginStage;
